import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
dayjs.extend(timezone);

const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function dateToLocal(date, withTime = false) {
  date = dayjs(date);

  if (!date.isValid()) {
    return false;
  }

  let format = "DD/MM/YYYY";
  if (withTime) {
    format += " HH:mm";
  }

  return date.tz(tz).format(format);
}

export function getDate(value) {
  return value ? dayjs(value) : dayjs();
}

export function getStartOfMonth(value, offset = 0) {
  return getDate(value).add(offset, "months").startOf("month");
}
